import { createContext } from "react";

const appContext = createContext(null);

export default appContext;
